import { useTranslation } from "react-i18next";

import { getSpecFormatter, SpecFormatter } from "../../../../commons/libs/formatters";
import { getSpecConfig } from "../../../../commons/specs";
import { ProductType } from "../../../../commons/specs/product";
import { CustomizationSettings } from "../../../../commons/types/settings";

const useSpecFormatter = <Type extends ProductType>(
  namespace: "commons" | "kiosk" | "mobile",
  productType: ProductType | undefined,
  customization: CustomizationSettings
): SpecFormatter<Type> | undefined => {
  const { i18n } = useTranslation([namespace]);

  if (!productType) {
    return undefined;
  }

  const specConfig = getSpecConfig(productType);

  return getSpecFormatter(productType, specConfig.specDefinitions, i18n, customization);
};

export default useSpecFormatter;
